import { Form, Input } from "antd";
import UploadImage from "../components/upload-image";

/* eslint-disable-next-line */
export interface AddPartTypeFormProps {
  name: string;
  setName: (name: string) => void;
  description: string;
  setDescription: (description: string) => void;
  image: string;
  setImage: (image: string) => void;
}

export function AddPartTypeForm(props: AddPartTypeFormProps) {
  const {
    name,
    setName,
    description,
    setDescription,
    image,
    setImage,
  } = props;

  return (
    <Form>
      <Form.Item label="Name">
        <Input value={name} onInput={(e) => setName(e.currentTarget.value)} />
      </Form.Item>
      <Form.Item label="Description">
        <Input value={description} onInput={(e) => setDescription(e.currentTarget.value)} />
      </Form.Item>
      <Form.Item label="Image">
        <UploadImage image={image} setImage={setImage} />
      </Form.Item>
    </Form>
  );
}

export default AddPartTypeForm;
